// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"nt-z","giftOrPromoSelector":"ot-z","disabled":"pt-z","subTitle":"qt-z","selectShipAddressMessage":"rt-z","changePayment":"st-z"};